export enum SignatureColumn {
	// `` is returned because once edited or a new value from the `New From` action is created, it must not be signed
	// `` is needed in order to differentiate between a untouched and a touched state. After each edit of signatures,
	// the signature should be empty, not null, in order to detect if it was already signed or not.
	IsPreviouslySignedValue = ''
}
